module.exports = __webpack_public_path__ + "static/media/buy_report_user_3.365f5c45.png";